import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { api } from "@/lib/api";
import { displayName } from "@/lib/auth";

interface Health {
  status: "ok" | "error";
  database: "ok" | "error";
}

interface Version {
  version: string;
  company: string;
}

export const Route = createFileRoute("/_authenticated/")({
  component: DashboardPage,
});

function DashboardPage() {
  const { user } = Route.useRouteContext();
  const health = useQuery({ queryKey: ["health"], queryFn: () => api<Health>("/health/") });
  const version = useQuery({ queryKey: ["version"], queryFn: () => api<Version>("/version/") });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Welcome, {displayName(user)}</h1>
        <p className="text-muted-foreground text-sm">
          Start from{" "}
          <Link to="/bols" className="underline">
            Bills of lading
          </Link>
          .
        </p>
      </div>
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>System</CardTitle>
          <CardDescription>Backend connectivity for this deployment.</CardDescription>
        </CardHeader>
        <CardContent>
          <dl className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-2 text-sm">
            <dt className="text-muted-foreground">API</dt>
            <dd>
              {health.isLoading
                ? "checking…"
                : health.isError
                  ? "unreachable"
                  : health.data?.status}
            </dd>
            <dt className="text-muted-foreground">Database</dt>
            <dd>{health.data?.database ?? "—"}</dd>
            <dt className="text-muted-foreground">Company</dt>
            <dd>{version.data?.company ?? "—"}</dd>
            <dt className="text-muted-foreground">Build</dt>
            <dd>{version.data?.version ?? "—"}</dd>
          </dl>
        </CardContent>
      </Card>
    </div>
  );
}
